import React from 'react';

const Footer = () => {
    return (
        <div className='p-6 sm:pb-2 md:pb-4 text-center bg-teal-900 text-white'>
            <p> &#8364; All right reserved. &#169; Team Code Tracker Bd. Copyright @ 2022 Edition. &#174;</p>
        </div>
    );
};

export default Footer;